import type { IconSvgObject } from './types';

const Delete04Icon: IconSvgObject = [
  ["path", { d: "M20 15L13 21.9995M20 22L13 15.0005", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 5.5L19.1061 12M4.5 5.5L5.38612 20.121C5.4501 21.1766 6.32488 22 7.38246 22H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 5.5L14.7597 2.60608C14.6022 2.2384 14.2406 2 13.8406 2H10.1594C9.75937 2 9.39783 2.2384 9.24025 2.60608L8 5.5M16 5.5H21M16 5.5H8M8 5.5H3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Delete04Icon;
